module.exports = __webpack_public_path__ + "925227cbdf42ff2a30d903290f1993e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/favorite/cafe-tra.jpg
// module id = ./assets/images/favorite/cafe-tra.jpg
// module chunks = 0